module.exports = __webpack_public_path__ + "img/selfAdhesive11.17b8cf6b.jpg";